import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';

import { PRICE_FEATURE_KEY } from './keys';
import { priceReducer } from './reducers/price.reducer';
import { PriceEffects } from './effects/price.effects';

export function providePriceStore(): EnvironmentProviders[] {
    return [provideState(PRICE_FEATURE_KEY, priceReducer), provideEffects(PriceEffects)];
}
